"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mqtt_connection = void 0;
class mqtt_connection {
    constructor(cfg) {
    }
    static get instance() { return mqtt_connection._staticInstance; }
    ensure_mqtt_connected(callbackWhenMessageRecieved) {
        this.processCallback = callbackWhenMessageRecieved;
    }
    process_messages() {
        return __awaiter(this, void 0, void 0, function* () {
            while (mqtt_connection.fakeReceiveBufer.length > 0) {
                const msg = mqtt_connection.fakeReceiveBufer.shift();
                const buffer = typeof msg === "string"
                    ? Buffer.from(msg, "ascii")
                    : msg;
                yield this.processCallback(null, "topic", [...buffer], buffer.length);
            }
        });
    }
    publish(arg0) {
        mqtt_connection.fakeReceiveBufer.push(arg0);
        mqtt_connection.publishedMessages.push(arg0);
        return true;
    }
    static simulateRecievedMessage(arg0) {
        mqtt_connection.fakeReceiveBufer.push(arg0);
    }
    send(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            mqtt_connection.fakeReceiveBufer.push(payload);
        });
    }
}
exports.mqtt_connection = mqtt_connection;
mqtt_connection.fakeReceiveBufer = [];
mqtt_connection.publishedMessages = [];
mqtt_connection._staticInstance = new mqtt_connection(null);
//# sourceMappingURL=mqtt_connection.js.map